module.exports = __webpack_public_path__ + "img/reset_filters.485f5209.svg";